const v3FeatureFlags = {
  views: {
    ABPolarity: true,
    AcknowledgedPass: false,
    ActivePass: false,
    AdminGuide: false,
    AppointmentPass: true,
    ArchivedUsers: false,
    AutoPass: true,
    ContactTracing: true,
    Dashboard: false,
    DigitalID: false,
    FileUploads: true,
    ForgottenPassword: false,
    HelpDeskPortal: false,
    KioskLaunch: true,
    KioskLogin: true,
    Kiosks: true,
    LimitActivePasses: true,
    LimitLocationAvailability: true,
    LimitLocationMaxCap: true,
    LimitStudentPass: true,
    Locked: false,
    Login: false,
    ModulesList: true,
    NewReleases: false,
    NotFound: false,
    OutOfOffice: true,
    PassBlocking: true,
    PassHistory: true,
    PassTimes: true,
    PassTransparency: true,
    Periods: true,
    QuickReference: false,
    ResetPassword: false,
    Rooms: true,
    StudentPass: false,
    SubstituteUsers: true,
    SummaryReports: true,
    TeacherGuide: false,
    TeacherPass: true,
    TrainingDocuments: false,
    UserSettings: true,
    Users: false,
    VideoTraining: false,
    FormComponentsExamples: true
  },
  components: {
    TheHeader: true,
    TheSidebar: true,
    HeaderActions: true,
    DataTable: true,
    DataTableOptimized: true
  }
}

const isV3Active = () => {
  // here you can add extra conditions
  // prod condition for switching from v3 to v2 (for everything):
  // return !appConfig.isProd
  return true
}
const isV3ViewVisible = (viewName = "") => {
  return !isV3Active()
    ? false
    : Object.hasOwn(v3FeatureFlags.views, viewName) &&
        v3FeatureFlags.views[viewName]
}

const isV3ComponentVisible = (componentName = "") => {
  return !isV3Active()
    ? false
    : Object.hasOwn(v3FeatureFlags.components, componentName) &&
        v3FeatureFlags.components[componentName]
}

export { isV3ViewVisible, isV3ComponentVisible }
